<template>
  <div class="dynamic-search-field row">
    <transition name="expand-icon">
      <mi-icon
        v-if="!searchFieldOpened"
        class="q-ma-md search-icon"
        name="search"
        @click="toggleSearchFieldOpened"
      >
      </mi-icon>
    </transition>
    <transition name="expand-field">
      <mi-text-field
        v-if="searchFieldOpened"
        v-model="searchStringValue"
        class="q-ml-md search-input"
        placeholder="Name, product model or planning period"
        outlined
        @keyup.enter="searchSavedCollections"
      >
        <template #append>
          <mi-icon
            name="close"
            class="cursor-pointer"
            @click="closeSearchField"
          ></mi-icon>
        </template>
      </mi-text-field>
    </transition>
  </div>
</template>

<script>
  import { inject, ref } from 'vue'
  import MiIcon from '../../packages/@mi-library/MiIcon/MiIcon.vue'
  import MiTextField from '../../packages/@mi-library/MiTextField/MiTextField.vue'
  import { SEARCH_STRING_PROVIDER } from './utils'

  export default {
    name: 'SavedCollectionsSearchField',
    components: { MiTextField, MiIcon },
    props: {
      fetchSavedCollections: {
        type: Function,
        required: true
      }
    },
    setup(props) {
      const searchFieldOpened = ref(false)
      const searchStringValue = inject(SEARCH_STRING_PROVIDER)

      const toggleSearchFieldOpened = () => {
        searchFieldOpened.value = !searchFieldOpened.value
      }

      const searchSavedCollections = () => {
        props.fetchSavedCollections()
      }

      const closeSearchField = () => {
        if (searchStringValue.value !== '') {
          searchStringValue.value = ''
          props.fetchSavedCollections()
        }
        toggleSearchFieldOpened()
      }

      return {
        searchFieldOpened,
        toggleSearchFieldOpened,
        searchStringValue,
        searchSavedCollections,
        closeSearchField
      }
    }
  }
</script>

<style lang="scss" scoped>
  .dynamic-search-field {
    color: #303c49;

    .mi-icon-close {
      background-color: #303c49;
      color: $mi-white;
      padding: 2px;
      border-radius: 50%;
      font-size: 10px;
    }

    .search-icon {
      cursor: pointer;
      margin-bottom: 0;
    }

    .search-input {
      width: 347px;
      padding: 0;
    }
  }

  .expand-field-enter-active,
  .expand-field-leave-active {
    transition: all 300ms ease;
  }

  .expand-field-enter-from,
  .expand-field-leave-to {
    opacity: 0;
    transform: scaleX(1);
    max-width: 0;
  }

  .expand-field-enter-to,
  .expand-field-leave-from {
    opacity: 1;
    transform: scaleX(1);
    max-width: 347px;
  }

  .expand-icon-enter-active {
    transition: all 400ms ease;
  }

  .expand-icon-enter-from,
  .expand-icon-leave-to {
    opacity: 0;
    transform: scaleX(1);
    max-width: 0;
  }

  .expand-icon-enter-to,
  .expand-icon-leave-from {
    opacity: 1;
    transform: scaleX(1);
  }
</style>
